// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SelectedTags-module__wrapper"};